import TransparentButton from '@/trio-ui/TransparentButton';
import * as Styles from './EmptyInterview.styles';

type EmptyInterviewType = {
  title?: string;
  subTitle?: string;
  onClick: () => void;
};

export default function EmptyInterview({
  title = 'There’s no interviews here yet.',
  subTitle = 'Start creating the first interview by clicking on “+ New Interview” on the left or on the button below.',
  onClick,
}: EmptyInterviewType): JSX.Element {
  return (
    <Styles.Box>
      <TransparentButton isBlueButton onClick={onClick}>
        + New Interview
      </TransparentButton>
      <Styles.Title>{title}</Styles.Title>
      <Styles.Subtitle>{subTitle}</Styles.Subtitle>
      <Styles.CustomButton onClick={onClick}>+ new interview</Styles.CustomButton>
    </Styles.Box>
  );
}
